<template>
    <div>
        <v-dialog v-model="casesubdetaildialog" max-width="2000px">
          <template v-slot:activator="{ on }">
            <v-btn color="primary" dark class="mb-2" v-on="on">+</v-btn>
          </template>
          <v-card>
            <v-card-title>
              <span class="headline" v-text="$t('ircasemaintenance.casesubjmaintenanceitem')" ></span>
            </v-card-title>

            <v-card-text>
                <v-container>
                    <v-form ref="form">
                        <v-row>
                            <v-col cols="4" sm="8" class="pb-n5 mt-3">
                                <v-autocomplete
                                outlined
                                :label="this.$t('columns.staffname')"
                                type="text"
                                ref="psnid"
                                :rules="[rules.required]"
                                v-model="selections[0].subjectid"
                                dense
                                :items="staffDetailsList"
                                @change="changeStaffIDandCompanyHandler(selections[0].subjectid)"
                                clearable
                                ></v-autocomplete>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="8" sm="4" class="pb-n5 mt-n8">
                                <v-text-field
                                    outlined
                                    :label="this.$t('columns.staffcode')"
                                    type="text"
                                    v-model="selections[0].staffcode"
                                    dense
                                    readonly
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>

                            <v-col cols="8" sm="4" class="pb-n5 mt-n8">
                                <v-text-field
                                    outlined
                                    :label="this.$t('attendancereportbypeiordbycompanyreport.companyname')"
                                    type="text"
                                    ref="compnyid"
                                    v-model="selections[0].compnyname"
                                    dense
                                    readonly
                                    append-icon=""
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="4" sm="4" class="pb-n6 mt-n8">
                                <v-autocomplete
                                    outlined
                                    :label="this.$t('ircasemaintenance.invlleveloutcome')"
                                    type="text"
                                    ref="involvementlvlid"
                                    clearable
                                    :items="involvementlvlList"
                                    hide-selected
                                    :rules="[rules.required]"
                                    v-model="selections[0].involvementlvlid"
                                    @change="changeInvolvementLvlCodeHandler(selections[0].involvementlvlid)"
                                    dense
                                ></v-autocomplete>
                            </v-col>

                            <v-col cols="2" sm="2" class="pb-n6 mt-n8">
                                <v-text-field
                                    dense
                                    :label="this.$t('columns.code')"
                                    outlined
                                    readonly
                                    background-color="#ffeab2"
                                    v-model="selections[0].involvementlvlcode"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="2" sm="2" class="pb-n6 mt-n8">
                                <v-dialog v-model="involvementlvlDialog" max-width="600px" persistent>
                                    <template v-slot:activator="{ on }">
                                        <v-btn dense v-on="on">
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <app-genericform
                                            v-bind:parentData = "{
                                                tabItems: involvementlvlItems,
                                                formTitle: this.$t('ircasemaintenance.invllevel'),
                                                formId: 'involvementlevel'
                                            }"

                                            v-on:input="itemData = $event"
                                            v-on:saveInvolvementLevel="saveIvolvementLevelCodeHandler"
                                            v-on:deleteInvolvementLevel="deleteInvolvementLevelCodeHandler($event)"
                                        />

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                color="warning"
                                                text
                                                @click="involvementlvlDialog = false" v-text="$t('button.close')">
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-col>
                        </v-row>

                     <!-- <v-row class="blue--text ">
                            <h4>Case Subject Supporting Document Control </h4>
                        </v-row> -->

                <!-- <v-row v-if="hidetable2">
                    <v-col col="12" sm="12" class="pb4-4">
                        <app-table2
                            v-bind:parentObject = "{
                                tabHeader: this.tabHeader2,
                                detailItem: this.selections[0].documentdetail,
                                staffid: this.selections[0].staffid
                            }"

                            v-on:input="addItemHandler2"
                        />
                    </v-col>
                </v-row>  -->

                        <v-row>
                            <v-col cols="12" sm="12" md="12" class="pb-n4 mt-n8">
                                <v-checkbox
                                    outlined
                                    v-model="selections[0].termination"
                                    :label="this.$t('ircasemaintenance.terminate')"
                                    @change="changeTerminationHandler(selections[0].termination)"
                                    dense
                                ></v-checkbox>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="2" md="2" class="pb-n4 mt-n8">
                                <v-text-field
                                outlined
                                :label="this.$t('columns.effectivedate')"
                                type="date"
                                dense
                                :disabled="!selections[0].termination"
                                :rules="[rules.requiredc(selections[0].effectivedate, selections[0].termination)]"
                                v-model="selections[0].effectivedate"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="2" sm="2" md="2" class="pb-n4 mt-n8">
                                <v-checkbox
                                    outlined
                                    v-model="selections[0].salsuspension"
                                    :label="this.$t('ircasemaintenance.salsuspension')"
                                    dense
                                    @change="changeSuspensionHandler(selections[0].salsuspension)"
                                ></v-checkbox>
                            </v-col>

                            <v-col cols="2" sm="2" md="2" class="pb-n4 mt-n8">
                                <v-text-field
                                    outlined
                                    :label="this.$t('ircasemaintenance.percntsuspend')"
                                    type="text"
                                    dense
                                    :disabled="!selections[0].salsuspension"
                                    v-model="selections[0].salsuspensionpcnt"
                                    :rules="[rules.requiredc(selections[0].salsuspensionpcnt, selections[0].salsuspension)]"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="2" md="2" class="pb-n4 mt-n8">
                                <v-text-field
                                outlined
                                :label="this.$t('ircasemaintenance.salsuspensionfrom')"
                                type="date"
                                dense
                                :disabled="!selections[0].salsuspension"
                                v-model="selections[0].salsuspstartdate"
                                :rules="[rules.requiredc(selections[0].salsuspstartdate, selections[0].salsuspension)]"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="2" md="2" class="pb-n4 mt-n8">
                                <v-text-field
                                outlined
                                :label="this.$t('ircasemaintenance.salsuspensionuntil')"
                                type="date"
                                dense
                                :disabled="!selections[0].salsuspension"
                                v-model="selections[0].salsuspenddate"
                                :rules="[rules.requiredc(selections[0].salsuspenddate, selections[0].salsuspension)]"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="12" md="12" class="pb-n4 mt-n8">
                                <v-checkbox
                                    outlined
                                    v-model="selections[0].svsuspension"
                                    :label="this.$t('ircasemaintenance.servicesuspension')"
                                    dense
                                    @change="changeServiceSuspensionHandler(selections[0].svsuspension)"
                                ></v-checkbox>
                            </v-col>
                        </v-row>

                        <v-row>
                            <v-col cols="12" sm="2" md="2" class="pb-n4 mt-n8">
                                <v-text-field
                                outlined
                                :label="this.$t('ircasemaintenance.servicesuspensionfrom')"
                                type="date"
                                dense
                                :disabled="!selections[0].svsuspension"
                                v-model="selections[0].svsuspstartdate"
                                :rules="[rules.requiredc(selections[0].svsuspstartdate, selections[0].svsuspension)]"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="2" md="2" class="pb-n4 mt-n8">
                                <v-text-field
                                outlined
                                :label="this.$t('ircasemaintenance.servicesuspensionuntil')"
                                type="date"
                                dense
                                :disabled="!selections[0].svsuspension"
                                v-model="selections[0].svsuspenddate"
                                :rules="[rules.requiredc(selections[0].svsuspenddate, selections[0].svsuspension)]"
                                ></v-text-field>
                            </v-col>
                        </v-row>

                    </v-form>
                </v-container>
            </v-card-text>

            <v-card-text v-if="isErr" class="mt-n12">
                <span style="font-weight: bold; color: red">{{errMsg}}</span>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="closeCaseSubjectInput" v-text="$t('button.cancel')"></v-btn>
              <v-btn color="green darken-1" text @click="saveCaseSubjectInput" v-text="$t('button.save')"></v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-data-table
            :headers="this.parentObject.tabHeader"
            :items="detailItem"
            class="elavation-1"
            fixed-header
            :sort-by="['code']"
        >
        <template v-slot:item.action="{ item }">
            <v-icon
                small
                class="mr-2"
                @click="modifyItemHandler(item)"
            >
                mdi-pen
            </v-icon>
            <v-icon
                small
                class="ml-3 mr-2"
                @click="deleteItemHandler(item)"
            >
                mdi-delete
            </v-icon>
        </template>

        </v-data-table>
    </div>
</template>

<script>
import compareArray from '../../../util/comparearray';
import GenericForm from '../../generic/GridForm';
//import CRUDTable2 from './CRUDTable2';

export default {
    props: {
        parentObject: Object
    },

    components: {
        'app-genericform': GenericForm,
        //"app-error": ErrorDialog,
       // 'app-table2' : CRUDTable2,
    },

    data() {
        return {

            rules: {
                required: value => !!value || 'Required.',
                percentage: value => !(value < 0 || value > 100) || 'Value is 1-100',
                requiredc: (value, value2) => {
                    if (value2) {
                        return !!value || 'Required.'
                    } else {
                        return true
                    }
                }
            },

            tabHeader2: [
               { text: 'Action', value: 'action', width: '80px', sortable: false},
               { text: 'Outcome/Action', value: 'outcomecode', width: '150px', sortable: true},
               { text: 'Date', value: 'outcomedate', width: '100px', sortable: true},
               { text: 'Respond Date', value: 'responddate', width: '100px', sortable: true},
               { text: 'Document Description', value: 'attachdesc', width: '200px', sortable: true},
               { text: 'Remark', value: 'remark', width: '120px', sortable: true},
            ],

            
            //    tableOpt: {
            //     itemsPerPage: -1
            // },

            casesubdetaildialog: false,
            detailItem: this.parentObject.detailItem,
            //documentdetail: this.parentObject.data.documentdetail,
            selections: [{
                id: null,
                casesubmaintenanceid: null,
                subjectid: null,
                psnid: null,
                psnname: null,
                staffcode: null,
                compnyid: null,
                compnyname: null,
                involvementlvlid: null,
                involvementlvlcode: null,
                involvementlvldesc: null,
                termination: false,
                effectivedate: null,
                salsuspension: false,
                salsuspensionpcnt: null,
                salsuspstartdate: null,
                salsuspenddate: null,
                svsuspension: false,
                svsuspstartdate: null,
                svsuspenddate: null,
                documentdetail: [],
                rectimestamp: null,
                updatedby: null,
                action: 1,
                stamp: 0,
                userid: this.$store.getters.userId,
            }],

            staffid: '',
            staffdetails: [],
            staffDetailsList: [],
            companies: [],
            companiesitemsList: [],
       
            itemHolder: [],
            hidetable2: false,


            itemData: {
                itemcode: null,
                itemdesc: null,
                itemstamp: 0
            },

            involvementlvlList: [],
            involvementlvls: [],
            involvementlvlItems: [],
            involvementlvlDialog: false,

            outcomeCode: '',
            outcomeList: [],
            outcomes: [],
            outcomeItems: [],
            outcomeDialog: false,
            outcomeLoading: true,

            modify: false,
            isExisting: false,
            isErr: false,
            errMsg: '',
        }
    },

 

    methods: {
        changeTerminationHandler(value) {
            if (value == false) {
                this.selections[0].effectivedate = null;
            }
        },

        changeSuspensionHandler(value) {
            if (value == false) {
                this.selections[0].salsuspensionpcnt = null;
                this.selections[0].salsuspstartdate = null;
                this.selections[0].salsuspenddate = null;
            }
        },

        changeServiceSuspensionHandler(value) {
            if (value == false) {
                this.selections[0].svsuspstartdate = null;
                this.selections[0].svsuspenddate = null;
            }
        },
        compareArray,

        addItemHandler2($event) {
            //console.log('docdetail2', this.selections.documentdetail)
            this.selections[0].documentdetail = [];
            this.selections[0].documentdetail = $event
            this.selections[0].staffid = this.selections[0].staffid;
            console.log('docdetail', this.selections[0].documentdetail)
            console.log('staffiddd', this.selections[0].staffid)
        },

         //load staffdetails list view
        loadStaffDetailsListHandler() {
            const vm = this;

            this.$store.dispatch('get', {url: "/staff/all/" + this.$store.getters.userId
})
                .then(res => {
                    //req success --> push res into array
                    if (res.data.rec.length == 0) return false
                    vm.staffdetails = res.data.rec;

                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.staffDetailsList.push({
                            text: res.data.rec[i].psndetails,
                            value: res.data.rec[i].id
                        });
                    }
                })
                .catch(err => {
                    //req failure --> emit error
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit("error", { isErr: vm.isErr, errMsg: vm.errMsg });
                });
        },

        //change staff id and company after selecting psnnid
        changeStaffIDandCompanyHandler(id) {
            let item = this.staffdetails.find(item => item.id === id);

            //set psnid to psnid and staffid to staffid
            this.selections[0].psnid = item.psnid;
            this.selections[0].staffid = item.id;
            this.selections[0].staffcode = item.staffcode;
            this.selections[0].compnyid = item.compnyid;
            this.selections[0].compnyname = item.compnyname;
            this.selections[0].psnname = item.psnname;
            this.crud();


        },

        crud(){
            console.log('.staffid', this.selections[0].staffid)

            this.hidetable2 = true;
            this.selections[0].staffid = this.selections[0].staffid;
        }, 
    
         loadInvolvementLevelListHandler() {
            const vm = this;

            this.$store.dispatch('get', {
                url: '/involvementlvl/all'
            })
                .then(res => {
                    if (res.data.rec.length == 0) return false
                    vm.involvementlvls = res.data.rec;

                    for (let i = 0; i < res.data.rec.length; i++) {
                        vm.involvementlvlList.push(
                            {
                                text: res.data.rec[i].involvementlvldesc,
                                value: res.data.rec[i].id
                            }
                        )

                        vm.involvementlvlItems.push(
                            {
                                id: res.data.rec[i].id,
                                code: res.data.rec[i].involvementlvlcode,
                                desc: res.data.rec[i].involvementlvldesc,
                                stamp: res.data.rec[i].stamp
                            }
                        )
                    }
                    
                    if (vm.selections[0].involvementlvlid) {
                        vm.changeInvolvementLvlCodeHandler(vm.selections[0].involvementlvlid);
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
        },

        //change handler is to show the loaded contents
        changeInvolvementLvlCodeHandler(id) {
            let item = this.involvementlvls.find(item => item.id === id);
            this.selections[0].involvementlvlcode = item.involvementlvlcode;
            this.selections[0].involvementlvldesc = item.involvementlvldesc; 
        },

         //save handler is for if the user wants to save a new item into the database
        saveIvolvementLevelCodeHandler() {
            const vm = this;

            if (this.itemData.itemid) {
                this.$store.dispatch('put', {
                    url: '/involvementlvl/' + this.itemData.itemid, 
                    payload: {
                        involvementlvlcode: this.itemData.itemcode,
                        involvementlvldesc: this.itemData.itemdesc,
                        stamp: this.itemData.itemstamp,
                        userid: this.$store.getters.userId,
                    }
                })
                .then(res => {
                    if (res.data.status == 201) {
                        // resets all arrays
                        vm.involvementlvls = [];
                        vm.involvementlvlItems = [];
                        vm.involvementlvlList = [];

                        this.loadInvolvementLevelListHandler();
                    } else {
                        vm.isErr = true;
                        vm.errMsg = res.data.error;
                        vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
            } else {
                this.$store.dispatch('post', {
                    url: '/involvementlvl/create', 
                    payload: {
                        involvementlvlcode: this.itemData.itemcode,
                        involvementlvldesc: this.itemData.itemdesc,
                        userid: this.$store.getters.userId,
                    }
                })
                .then(res => {
                    if (res.data.status == 201) {
                        // resets all arrays
                        vm.involvementlvls = [];
                        vm.involvementlvlItems = [];
                        vm.involvementlvlList = [];

                        this.loadInvolvementLevelListHandler();
                    } else {
                        vm.isErr = true;
                        vm.errMsg = res.data.error;
                        vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
            }
        },

        //delete handler is for the user to delete an item from the database
        deleteInvolvementLevelCodeHandler($event) {
        const vm = this;

            if (confirm('Remove ' + $event.desc + '?')) {
                this.$store.dispatch('delete', {
                    url: '/involvementlvl/' + $event.id + '/' + this.$store.getters.userId
                })
                .then(res => {
                    if (res.data.status == 200) {
                        // resets all arrays
                        vm.involvementlvls = [];
                        vm.involvementlvlList = [];
                        vm.involvementlvlItems = [];

                        this.loadInvolvementLevelListHandler();
                    } else {
                        vm.isErr = true;
                        vm.errMsg = res.data.error;
                        vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });                
            }
        },

        genInvolvementLevelTabItems() {
            if (this.involvementlvls.length == 0) return false
            for (let i = 0; i < this.involvementlvls.length; i++) {
                this.involvementlvlItems.push(
                    {
                        id: this.involvementlvls[i].id,
                        code: this.involvementlvls[i].involvementlvlcode,
                        desc: this.involvementlvls[i].involvementlvldesc,
                        stamp: this.involvementlvls[i].stamp
                    }
                )
            }
        },

        
        modifyItemHandler(item) {
            if (item.action === 1) {
                this.modify = true
            }
            this.selections[0].action = item.action
            this.selections[0].id = item.id
            this.selections[0].subjectid = item.subjectid
            this.selections[0].staffcode = item.staffcode
            this.selections[0].compnyname = item.compnyname
            this.changeStaffIDandCompanyHandler(this.selections[0].subjectid)
            this.selections[0].involvementlvlid = item.involvementlvlid
            this.selections[0].involvementlvlcode = item.involvementlvlcode
            this.changeInvolvementLvlCodeHandler(this.selections[0].involvementlvlid)

            if (item.termination === 'N') {
                this.selections[0].termination = false
            } else {
                this.selections[0].termination = true
            }

            if (item.salsuspension === 'N') {
                this.selections[0].salsuspension = false
            } else {
                this.selections[0].salsuspension = true
            }

            if (item.svsuspension === 'N') {
                this.selections[0].svsuspension = false
            } else {
                this.selections[0].svsuspension = true
            }

            this.selections[0].effectivedate = item.effectivedate
            this.selections[0].salsuspensionpcnt = item.salsuspensionpcnt
            this.selections[0].salsuspstartdate = item.salsuspstartdate
            this.selections[0].salsuspenddate = item.salsuspenddate
            this.selections[0].svsuspstartdate = item.svsuspstartdate
            this.selections[0].svsuspenddate = item.svsuspenddate
            this.casesubdetaildialog = true;
        },

        deleteItemHandler(item) {
            let itemIndex = this.detailItem.indexOf(item);

            this.detailItem.splice(itemIndex, 1);
            this.$emit("input", this.detailItem);
        },
       
        closeCaseSubjectInput() {
            this.casesubdetaildialog = false;
            this.isErr = false;
            this.isExisting = false;

            // reset the form fields
            this.resetSelections();
        },

        
        saveCaseSubjectInput() {
            if (!this.$refs.form.validate()){
                if (this.selections[0].subjectid == null || this.selections[0].involvementlvlid == null){
                    this.$dialog.alert("Fill in the Staff Name and Involvement Level columns").then((dialog) => {
                        console.log(dialog);
                    });
                }
                return false
            } else {
                this.isErr = false;

                if (!this.selections[0].termination) {
                    this.selections[0].termination = 'N'
                } else {
                    this.selections[0].termination = 'Y'
                }

                if (!this.selections[0].salsuspension) {
                    this.selections[0].salsuspension = 'N'
                } else {
                    this.selections[0].salsuspension = 'Y'
                }

                if (!this.selections[0].svsuspension) {
                    this.selections[0].svsuspension = 'N'
                } else {
                    this.selections[0].svsuspension = 'Y'
                }
                
                if (this.selections[0].action == 1 && !this.modify) {
                    this.detailItem.push(Object.assign({}, this.selections[0]));
                } else {
                    let i = this.detailItem.findIndex(obj => obj.id === this.selections[0].id);
                    this.detailItem[i].subjectid = this.selections[0].subjectid;
                    this.detailItem[i].involvementlvlid = this.selections[0].involvementlvlid
                    this.detailItem[i].involvementlvlcode = this.selections[0].involvementlvlcode
                    this.detailItem[i].termination = this.selections[0].termination
                    this.detailItem[i].effectivedate = this.selections[0].effectivedate
                    this.detailItem[i].salsuspension = this.selections[0].salsuspension
                    this.detailItem[i].salsuspensionpcnt =  this.selections[0].salsuspensionpcnt
                    this.detailItem[i].salsuspstartdate = this.selections[0].salsuspstartdate
                    this.detailItem[i].salsuspenddate = this.selections[0].salsuspenddate
                    this.detailItem[i].svsuspension = this.selections[0].svsuspension
                    this.detailItem[i].svsuspstartdate = this.selections[0].svsuspstartdate
                    this.detailItem[i].svsuspenddate = this.selections[0].svsuspenddate
                }

                this.$emit("input", this.detailItem);
                this.casesubdetaildialog = false;
                this.resetSelections();
            }
        },

       
        resetSelections() {
            this.modify = false
            this.selections = [{
                id: null,
                casesubmaintenanceid: null,
                subjectid: null,
                psnid: null,
                psnname: null,
                staffcode: null,
                compnyid: null,
                compnyname: null,
                involvementlvlid: null,
                involvementlvlcode: null,
                involvementlvldesc: null,
                termination: false,
                effectivedate: null,
                salsuspension: false,
                salsuspensionpcnt: null,
                salsuspstartdate: null,
                salsuspenddate: null,
                svsuspension: false,
                svsuspstartdate: null,
                svsuspenddate: null,
                documentdetail: [],
                rectimestamp: null,
                updatedby: null,
                stamp: 0,
                action: 1,
                userid: this.$store.getters.userId,
            }]

            if(this.selections[0].staffid == null){
            this.hidetable2 = false;
            }
        },

    },

    created() {
        this.loadStaffDetailsListHandler();
        this.loadInvolvementLevelListHandler();
    }
}
</script>   